/**
 * BenefitsScroll Component
 * 
 * Displays scrolling benefits cards with animations.
 */

import React from 'react';
import { Droplets, Zap, Citrus, Rocket, Moon } from 'lucide-react';

const BENEFITS = [
  { icon: <Droplets className="w-12 h-12 text-[#ff00ff]" />, title: "Hydration & Recovery" },
  { icon: <Zap className="w-12 h-12 text-[#ff00ff]" />, title: "Supports Daily Energy Production" },
  { icon: <Citrus className="w-12 h-12 text-[#ff00ff]" />, title: "Essential Vitamins & Minerals" },
  { icon: <Rocket className="w-12 h-12 text-[#ff00ff]" />, title: "Supports Daily Performance" },
  { icon: <Moon className="w-12 h-12 text-[#ff00ff]" />, title: "Morning-After Recovery" }
];

export const BenefitsScroll: React.FC = () => {
  const tripleSetBenefits = [...BENEFITS, ...BENEFITS, ...BENEFITS];
  
  return (
    <div className="benefits-scroll-container">
      <div className="benefits-scroll-content">
        {tripleSetBenefits.map((benefit, index) => (
          <div key={index} className="benefit-card">
            <div className="group relative glass-panel rounded-xl p-6 border border-white/10 hover:border-[#ff00ff]/20 hover-glow cursor-pointer overflow-hidden h-[280px] w-[240px] flex items-center justify-center">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#ff00ff]/10 to-[#00ffff]/10 rounded-full blur-2xl transform translate-x-8 -translate-y-8 group-hover:scale-150 transition-transform duration-500" />
              <div className="relative flex flex-col items-center justify-center h-full w-full">
                <div className="w-16 h-16 mb-6">
                  {React.cloneElement(benefit.icon, {
                    className: "w-16 h-16 text-[#ff00ff] group-hover:text-[#ff66ff] transition-colors duration-300"
                  })}
                </div>
                <h3 className="font-bold text-center gradient-text group-hover:from-[#ff00ff] group-hover:via-white group-hover:to-[#00ffff] transition-all duration-300 text-xl px-2">
                  {benefit.title}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};